import React, { useEffect, useState } from 'react';
import axiosInstance from '../../interceptor/axiosInstance';
import '../Dashboard/Dashboard.css';

const ProfilePage = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await axiosInstance.get('/api/user/profiles');
        setUser(response.data[0]);
      } catch (err) {
        setError(err.message);
      }
    };
    fetchUserDetails();
  }, []);

  // Get initials for avatar
  const getInitials = (name) => {
    if (!name) return '?';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  if (error) {
    return (
      <div className="profile-page">
        <div className="profile-card" style={{ textAlign: 'center' }}>
          <p style={{ color: '#bb0403', fontSize: '15px' }}>⚠️ {error}</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="profile-page">
        <div className="profile-card" style={{ textAlign: 'center' }}>
          <div className="dash-spinner" style={{ minHeight: 'auto', padding: '40px 0' }}>
            <div className="spinner-ring"></div>
          </div>
        </div>
      </div>
    );
  }

  const fields = [
    { icon: '👤', label: 'Full Name', value: user.name },
    { icon: '📧', label: 'Email Address', value: user.email },
    { icon: '📞', label: 'Phone Number', value: user.phone || '—' },
  ];

  return (
    <div className="profile-page">
      <div className="profile-card">
        {/* Avatar */}
        <div className="profile-avatar">{getInitials(user.name)}</div>
        <div className="profile-name">{user.name}</div>
        <div className="profile-role">Account Member</div>
        <div className="profile-divider"></div>

        {/* Fields */}
        {fields.map((f) => (
          <div className="profile-field" key={f.label}>
            <div className="profile-field-icon">{f.icon}</div>
            <div>
              <div className="profile-field-label">{f.label}</div>
              <div className="profile-field-value">{f.value}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfilePage;
